import React from "react";
import styled from "styled-components";

const SwitchInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
`;

const SwitchLabel = styled.label<{
  isChecked: boolean;
  width?: string;
  height?: string;
  backgroundColor?: string;
  defaultBackgroundColor?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: ${(props) => props.width || "48px"};
  height: ${(props) => props.height || "24px"};
  border-radius: 20px;
  position: relative;
  transition: background-color 0.4s;
  background-color: ${(props) =>
    props.isChecked
      ? props.backgroundColor
        ? props.backgroundColor
        : props.theme.accent.normal
      : props.defaultBackgroundColor
      ? props.defaultBackgroundColor
      : "rgba(255, 255, 255,0.1)"};
`;

const SwitchButton = styled.span<{
  backgroundColor?: string;
  size?: number;
  top?: number;
  left?: number;
}>`
  content: "";
  position: absolute;
  top: ${(props) => props.top || 3}px;
  left: ${(props) => props.left || 4}px;
  width: ${(props) => props.size || 18}px;
  height: ${(props) => props.size || 18}px;
  border-radius: 20px;
  transition: 0.4s;
  background-color: ${(props) =>
    props.backgroundColor || props.theme.primaryColor};
  ${SwitchInput}:checked + ${SwitchLabel} & {
    left: calc(100% - ${(props) => props.left || 4}px);
    transform: translateX(-100%);
  }
`;

export type SwitchProps = {
  name?: string;
  toggled: boolean;
  id?: string;
  width?: string;
  height?: string;
  size?: number;
  labelBackgroundColor?: string;
  labelDefaultBackgroundColor?: string;
  buttonBackgroundColor?: string;
  top?: number;
  left?: number;
  onChange: (checked: boolean) => void;
};

const Switch = ({
  name,
  id,
  toggled,
  width,
  height,
  size,
  labelBackgroundColor,
  labelDefaultBackgroundColor,
  buttonBackgroundColor,
  top,
  left,
  onChange,
}: SwitchProps) => {
  return (
    <>
      <SwitchInput
        name={name}
        id={id}
        type="checkbox"
        checked={toggled}
        onChange={(e) => onChange(e.currentTarget.checked)}
      />
      <SwitchLabel
        width={width}
        height={height}
        defaultBackgroundColor={labelDefaultBackgroundColor}
        backgroundColor={labelBackgroundColor}
        isChecked={toggled}
        htmlFor={id}
      >
        <SwitchButton
          backgroundColor={buttonBackgroundColor}
          size={size}
          top={top}
          left={left}
        />
      </SwitchLabel>
    </>
  );
};

export default Switch;
